import { Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ApiResultModal } from '../../../../components/modal/ApiResultHandler';
import { ApproveModal } from '../../../../components/modal/ApproveModal';
import { ModalText, useModalToggle } from '../../../../components/modal/Modal';
import { WarningButton } from '../../../../components/style/ButtonStyle';
import { useAuthAxios } from '../../../../hooks/useAuthAxios';

export default function DeleteUserButton({ userId, styleProps = {} }: any) {
  const [removeResult, remove] = useAuthAxios({
    method: 'DELETE',
    url: `/api/v1/user/${userId}`,
  });
  const { on, open, close } = useModalToggle();
  const navigate = useNavigate();
  return (
    <>
      <WarningButton onClick={open} sx={styleProps}>
        계정 삭제
      </WarningButton>
      <ApproveModal
        on={on}
        onClose={close}
        title="삭제하시겠습니까?"
        children={
          <Stack direction="row" justifyContent="center" sx={{ pt: 3, pb: 5 }}>
            <ModalText>삭제된 데이터는 복구되지 않습니다.</ModalText>
          </Stack>
        }
        onConfirm={() => remove()}
        isPrimaryColor={false}
      />

      <ApiResultModal
        apiResult={removeResult}
        successCode={200}
        successTitle={<>삭제되었습니다.</>}
        successContent={`해당 계정은 로그아웃 되었습니다.`}
        successConfirmText="목록으로 돌아가기"
        onSuccessClose={() => {
          navigate(`/users`);
        }}
        failTitle={<>관리자에게 문의해주세요.</>}
        failContent={'문제가 발생했습니다. 관리자에게 문의해주세요.'}
      ></ApiResultModal>
    </>
  );
}
